import type { HTMLAttributes, ReactNode } from "react";

export type CardProps = HTMLAttributes<HTMLDivElement> & {
  title?: ReactNode;
  children: ReactNode;
};

export function Card({ title, children, className, ...rest }: CardProps) {
  return (
    <div className={["ax-card", className].filter(Boolean).join(" ")} {...rest}>
      {title != null ? <h3 className="ax-card__title">{title}</h3> : null}
      {children}
    </div>
  );
}
